define('dcf-search-select',["exports", "./dcf-utility"], function (_exports, _dcfUtility) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.DCFSearchSelectTheme = _exports.DCFSearchSelect = void 0;
  function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
  function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
  function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
  function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
  function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
  function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
  function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
  function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
  function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
  function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
  function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
  function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
  function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
  function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
  function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
  function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
  function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
  function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
  function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
  // These are used to parse the select into a know structure
  /**
   * @typedef {Object} ParsedOption
   * @property {'option'} tag - The option's tag
   * @property {string} label - The option's label
   * @property {string} value - The option's value
   * @property {bool} disabled - If option is disabled
   * @property {bool} selected - If option is selected
   * @property {string} id - The option's unique ID
   * @property {HTMLOptionElement} element - The options's original element
   */
  /**
   * @typedef {Object} ParsedOptgroup
   * @property {'optgroup'} tag - The optgroup tag
   * @property {string} label - The optgroup's label
   * @property {HTMLOptGroupElement|HTMLSelectElement} element - The optgroup's original element
   * @property {Array<ParsedOption>} items - The optgroup's children
   */
  /**
   * @typedef {Object} ParseSelectInner
   * @property {Array<ParsedOptgroup>} optgroups - A list of optgroups found
   * @property {Array<ParsedOption>} options - A list of options found
   */
  /** Styling for the Search and Select component */
  // eslint-disable-next-line padded-blocks
  var DCFSearchSelectTheme = /*#__PURE__*/function () {
    /**
     * Constructor for the class,
     * this will build the variables with their default values
     */
    function DCFSearchSelectTheme() {
      _classCallCheck(this, DCFSearchSelectTheme);
      this.searchAndSelectClassList = ['dcf-relative'];
      this.searchAreaClassList = ['dcf-relative', 'dcf-d-grid', 'dcf-overflow-x-hidden', 'dcf-overflow-y-auto'];
      this.selectedItemsListClassList = ['dcf-d-flex', 'dcf-flex-wrap', 'dcf-m-0'];
      this.selectedItemClassList = ['dcf-d-flex', 'dcf-flex-nowrap', 'dcf-ai-center', 'dcf-jc-center', 'dcf-mb-0', 'dcf-relative'];
      this.selectedItemButtonClassList = ['dcf-btn', 'dcf-btn-secondary', 'dcf-h-100%', 'dcf-z-1'];
      this.selectedItemButtonSVG = "\n      <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 26 26\" class=\"dcf-fill-current dcf-w-4 dcf-h-4 dcf-d-block\">\n        <path d=\"M25.4,22.6L15.8,13l9.6-9.6C25.8,3,26,2.5,26,2s-0.2-1-0.6-1.4c-0.8-0.8-2.1-0.8-2.8,0L13,10.2L3.4,0.6\n          c-0.8-0.8-2-0.8-2.8,0c-0.8,0.8-0.8,2,0,2.8l9.6,9.6l-9.6,9.6C0.2,23,0,23.5,0,24c0,0.5,0.2,1,0.6,1.4C1,25.8,1.5,26,2,26\n          c0.5,0,1-0.2,1.4-0.6l9.6-9.6l9.6,9.6C23,25.8,23.5,26,24,26c0,0,0,0,0,0c0.5,0,1-0.2,1.4-0.6C25.8,25,26,24.5,26,24\n          C26,23.5,25.8,23,25.4,22.6z\"/>\n      </svg>\n    ";
      this.selectedItemLabelClassList = ['dcf-h-100%'];
      this.toggleButtonContainerClassList = ['dcf-sticky', 'dcf-top-50%', 'dcf-h-0', 'dcf-pl-1', 'dcf-pr-1'];
      this.toggleButtonClassList = ['dcf-btn', 'dcf-btn-tertiary', 'dcf-p-3'];
      this.toggleButtonSVG = "\n      <svg\n        xmlns=\"http://www.w3.org/2000/svg\"\n        viewBox=\"0 0 24 24\"\n        class=\"dcf-fill-current dcf-w-3 dcf-h-3 dcf-d-block\"\n        aria-hidden=\"true\"\n      >\n        <path d=\"M23.936,2.255C23.848,2.098,23.681,2,23.5,2h-23\n          C0.32,2,0.153,2.098,0.065,2.255c-0.089,0.157-0.085,0.35,0.008,0.504\n          l11.5,19C11.663,21.908,11.826,22,12,22s0.337-0.092,0.428-0.241\n          l11.5-19C24.021,2.605,24.025,2.412,23.936,2.255z\"></path>\n      </svg>\n    ";
      this.inputSingleClassList = ['dcf-b-0'];
      this.inputGroupMultiple = ['dcf-d-flex', 'dcf-flex-wrap'];
      this.inputMultipleClassList = ['dcf-b-0', 'dcf-flex-grow-1', 'dcf-flex-shrink-0'];
      this.availableItemsListClassList = ['dcf-absolute', 'dcf-d-none', 'dcf-mb-0', 'dcf-pl-0', 'dcf-w-100%', 'dcf-z-2'];
      this.availableItemsGroupClassList = ['dcf-m-0', 'dcf-pl-0'];

      // eslint-disable-next-line id-length
      this.availableItemsGroupLabelClassList = ['dcf-mb-0', 'dcf-bold'];
      this.availableItemClassList = ['dcf-relative', 'dcf-d-flex', 'dcf-flex-row', 'dcf-flex-nowrap', 'dcf-jc-between', 'dcf-ai-center', 'dcf-mb-0'];
      this.availableItemIndicatorSVG = "\n      <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" class=\"dcf-fill-current dcf-h-4 dcf-w-4 dcf-d-block\">\n        <path d=\"M31,0.4C30.6,0.1,30-0.1,29.4,0c-0.6,0.1-1.1,0.4-1.5,0.9\n        L10.1,26.3L3.8,20c-0.4-0.4-1-0.6-1.6-0.6c0,0,0,0,0,0\n        c-0.6,0-1.2,0.2-1.6,0.6C0.2,20.5,0,21,0,21.6\n        c0,0.6,0.2,1.2,0.7,1.6l8.1,8.1c0.4,0.4,1,0.7,1.6,0.7\n        c0.7,0,1.4-0.4,1.8-1L31.6,3.5\n        C32.3,2.5,32.1,1.1,31,0.4z\"/>\n      </svg>\n    ";
      this.availableItemsNoResultsClassList = ['dcf-mb-0', 'dcf-bold'];
    }

    // Allows us to set the theme variables if they are defined and we match the types
    _createClass(DCFSearchSelectTheme, [{
      key: "setThemeVariable",
      value: function setThemeVariable(themeVariableName, value) {
        if (themeVariableName in this && _typeof(value) == _typeof(this[themeVariableName])) {
          this[themeVariableName] = value;
        }
      }
    }]);
    return DCFSearchSelectTheme;
  }();
  /** This is the class for a single instance of a single-select combobox */
  // eslint-disable-next-line padded-blocks
  _exports.DCFSearchSelectTheme = DCFSearchSelectTheme;
  var DCFSearchSelectSingle = /*#__PURE__*/function () {
    /**
     * Constructor for the multi-select combobox
     * @param { HTMLSelectElement } selectElement The select that will be used to build the component
     * @param { DCFSearchSelectTheme | null } theme The theme to be used to build the component
     */
    function DCFSearchSelectSingle(selectElement) {
      var _this$searchAndSelect;
      var theme = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      _classCallCheck(this, DCFSearchSelectSingle);
      // If no theme is provided then we will create the default one
      if (theme instanceof DCFSearchSelectTheme) {
        this.theme = theme;
      } else {
        this.theme = new DCFSearchSelectTheme();
      }
      this.selectElement = selectElement;

      // We will create a random ID per component
      this.uuid = _dcfUtility.DCFUtility.uuidv4();

      // These are the IDs that will be used for the whole component
      this.selectID = this.selectElement.getAttribute('id') || this.uuid.concat('-search-and-select-select');
      this.searchAndSelectID = this.uuid.concat('-search-and-select');
      this.inputID = this.uuid.concat('-search-and-select-input');
      this.availableItemsListID = this.uuid.concat('-search-and-select-available-items-list');

      // This is the core markup for the component
      this.searchAndSelectElement = document.createElement('div');
      this.searchAndSelectElement.innerHTML = "\n      <div class=\"dcf-search-and-select-search-area-single ".concat(this.theme.searchAreaClassList.join(' '), "\" >\n        <input\n          class=\"").concat(this.theme.inputSingleClassList.join(' '), "\"\n          type=\"text\"\n          role=\"combobox\"\n          id=").concat(this.inputID, "\n          aria-haspopup=\"listbox\"\n          aria-autocomplete=\"list\"\n          aria-expanded=\"false\"\n          aria-controls=\"").concat(this.availableItemsListID, "\"\n        >\n        <div class=\"dcf-search-and-select-open-btn ").concat(this.theme.toggleButtonContainerClassList.join(' '), "\">\n          <button\n            class=\"").concat(this.theme.toggleButtonClassList.join(' '), "\"\n            type=\"button\"\n            tabindex=\"-1\"\n            aria-label=\"Toggle Selectable List\"\n            aria-expanded=\"false\"\n            aria-controls=\"").concat(this.availableItemsListID, "\"\n          >\n            ").concat(this.theme.toggleButtonSVG, "\n          </button>\n        </div>\n      </div>\n    ");
      (_this$searchAndSelect = this.searchAndSelectElement.classList).add.apply(_this$searchAndSelect, ['dcf-search-and-select'].concat(_toConsumableArray(this.theme.searchAndSelectClassList)));
      this.searchAndSelectElement.setAttribute('id', this.searchAndSelectID);
      this.searchAndSelectElement.setAttribute('hidden', 'hidden'); // This will be removed later in the constructor
      this.searchAndSelectElement.dataset.for = this.selectID;

      // We will select the items for use in the rest of the component
      this.inputElement = this.searchAndSelectElement.querySelector('input');
      this.openButtonElement = this.searchAndSelectElement.querySelector('.dcf-search-and-select-open-btn button');
      this.searchAreaElement = this.searchAndSelectElement.querySelector('.dcf-search-and-select-search-area-single');

      // We will parse the select element and build the available items from that
      this.parsedSelect = this.parseSelect();

      // These will hold the current state of the component
      this.currentFocus = null;
      this.listOfAvailableItems = [];
    }

    /**
     * This will use the values from the constructors
     * This is needed due to the extends on the multi
     */
    _createClass(DCFSearchSelectSingle, [{
      key: "init",
      value: function init() {
        var _this$availableItemsL;
        this.selectElement.after(this.searchAndSelectElement);

        // In the multi-select buildAvailableItems will use the selectedItemsList
        // If we did not have init this step would break and cause errors
        this.availableItemsListElement = this.buildAvailableItems();
        this.availableItemsListElement.setAttribute('id', this.availableItemsListID);
        (_this$availableItemsL = this.availableItemsListElement.classList).add.apply(_this$availableItemsL, ['dcf-search-and-select-available-items'].concat(_toConsumableArray(this.theme.availableItemsListClassList)));
        this.searchAndSelectElement.append(this.availableItemsListElement);
        this.fixSelectReferences();
        this.transferSelectAttributes();
        this.setDisabled(this.selectElement.getAttribute('disabled') !== null);
        this.setReadOnly(this.selectElement.getAttribute('readonly') !== null);

        // We will finish setting up the event listeners and un-hide the element
        this.addEventListeners();
        this.searchAndSelectElement.removeAttribute('hidden');
      }

      /**
       * Fix any references to the hidden select
       */
    }, {
      key: "fixSelectReferences",
      value: function fixSelectReferences() {
        var _this = this;
        var attributesToFix = ['for', 'aria-controls', 'aria-describedby'];
        attributesToFix.forEach(function (singleAttr) {
          document.querySelectorAll("[".concat(singleAttr, "=\"").concat(_this.selectID, "\"]")).forEach(function (elementToFix) {
            elementToFix.setAttribute(singleAttr, _this.inputID);
          });
        });
      }

      /**
       * If the select element has attributes set it will transfer them to the input
       */
    }, {
      key: "transferSelectAttributes",
      value: function transferSelectAttributes() {
        var _this2 = this;
        var attributesToFix = ['aria-describedby', 'aria-label', 'aria-labelledby', 'aria-owns'];
        attributesToFix.forEach(function (singleAttr) {
          if (_this2.selectElement.getAttribute(singleAttr) !== null) {
            _this2.inputElement.setAttribute(singleAttr, _this2.selectElement.getAttribute(singleAttr));
          }
        });
      }

      /**
       * Recursively parses the select/optgroups
       * @returns { Array<ParsedOptgroup> }
       */
    }, {
      key: "parseSelect",
      value: function parseSelect() {
        var returnedData = this.parseSelectInner(this.selectElement);
        var optgroups = returnedData.optgroups;
        if (returnedData.options.length > _dcfUtility.DCFUtility.magicNumbers('int0')) {
          optgroups.push({
            tag: 'optgroup',
            label: 'Other',
            element: this.selectElement,
            items: returnedData.options
          });
        }
        return optgroups;
      }

      /**
       * Recursively parses the select/optgroups
       * @param { HTMLSelectElement|HTMLOptGroupElement } selectOrOptgroup The select or optgroup to parse
       * @returns { ParseSelectInner }
       */
    }, {
      key: "parseSelectInner",
      value: function parseSelectInner(selectOrOptgroup) {
        var optgroups = [];
        var options = [];
        var _iterator = _createForOfIteratorHelper(selectOrOptgroup.children),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var optgroupOrOption = _step.value;
            if (optgroupOrOption.tagName === 'OPTGROUP') {
              var returnedData = this.parseSelectInner(optgroupOrOption);
              var returnedOptgroups = returnedData.optgroups;
              optgroups.push.apply(optgroups, _toConsumableArray(returnedOptgroups));
              optgroups.push({
                tag: 'optgroup',
                label: optgroupOrOption.getAttribute('label'),
                element: optgroupOrOption,
                items: returnedData.options
              });
            } else if (optgroupOrOption.tagName === 'OPTION') {
              options.push({
                tag: 'option',
                label: optgroupOrOption.innerHTML,
                value: optgroupOrOption.getAttribute('value'),
                selected: optgroupOrOption.getAttribute('selected') !== null,
                disabled: optgroupOrOption.getAttribute('disabled') !== null,
                id: _dcfUtility.DCFUtility.uuidv4().concat('-search-and-select-option'),
                element: optgroupOrOption
              });
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        return {
          optgroups: optgroups,
          options: options
        };
      }

      /**
       * Builds the available items UL from output of parse select
       * @returns { HTMLUListElement }
       */
    }, {
      key: "buildAvailableItems",
      value: function buildAvailableItems() {
        var _this3 = this;
        var availableItems = document.createElement('ul');
        availableItems.setAttribute('role', 'listbox');
        var lastSelectedOption = null;
        this.parsedSelect.forEach(function (singleOptgroup) {
          var _groupedItems$classLi;
          var groupedItems = document.createElement('ul');
          groupedItems.setAttribute('role', 'group');
          (_groupedItems$classLi = groupedItems.classList).add.apply(_groupedItems$classLi, ['dcf-search-and-select-available-items-group'].concat(_toConsumableArray(_this3.theme.availableItemsGroupClassList)));
          if (_this3.parsedSelect.length !== _dcfUtility.DCFUtility.magicNumbers('int1')) {
            groupedItems.innerHTML = "\n        ".concat(groupedItems.innerHTML, "\n        <li\n          class=\"").concat(_this3.theme.availableItemsGroupLabelClassList.join(' '), "\"\n          role=\"presentation\"\n        >\n          ").concat(singleOptgroup.label, "\n        </li>\n      ");
          }
          singleOptgroup.items.forEach(function (singleItem) {
            var _newItem$classList;
            var newItem = document.createElement('li');
            (_newItem$classList = newItem.classList).add.apply(_newItem$classList, ['dcf-search-and-select-available-item', 'dcf-search-and-select-clickable'].concat(_toConsumableArray(_this3.theme.availableItemClassList)));
            newItem.setAttribute('role', 'option');
            newItem.setAttribute('aria-selected', 'false');
            newItem.setAttribute('aria-disabled', singleItem.disabled);
            newItem.setAttribute('id', "".concat(singleItem.id, "-available"));
            newItem.dataset.value = singleItem.value;
            newItem.dataset.label = singleItem.label;
            newItem.dataset.id = singleItem.id;
            newItem.innerHTML = "\n          <span class=\"dcf-search-and-select-available-item-label\">\n            ".concat(singleItem.label, "\n          </span>\n          <span class=\"dcf-search-and-select-available-item-indicator\" aria-hidden=\"true\">\n            ").concat(_this3.theme.availableItemIndicatorSVG, "\n          </span>\n        ");
            groupedItems.append(newItem);
            if (singleItem.disabled === false && singleItem.selected === true) {
              lastSelectedOption = newItem;
            }
          });
          availableItems.append(groupedItems);
        });
        if (lastSelectedOption !== null) {
          lastSelectedOption.setAttribute('aria-selected', 'true');
          this.inputElement.value = lastSelectedOption.dataset.label;
        }
        return availableItems;
      }

      /**
       * Add event listeners for the different parts of the search and select element
       */
    }, {
      key: "addEventListeners",
      value: function addEventListeners() {
        var _this4 = this;
        document.body.addEventListener('pointerup', function (event) {
          if (!_this4.searchAndSelectElement.contains(event.target)) {
            _this4.closeAvailableItems();
            _this4.setVisualFocusOn(false);
          }
        }, true);
        this.searchAreaElement.addEventListener('click', function () {
          if (_this4.isComponentDisabled()) {
            return;
          }
          _this4.setVisualFocusOn(_this4.searchAreaElement);
          _this4.inputElement.focus();
          if (_this4.isComponentReadOnly() || _this4.isAvailableItemsOpen()) {
            _this4.closeAvailableItems();
          } else {
            _this4.filterAvailableItems();
            _this4.openAvailableItems();
          }
        });
        this.inputElement.addEventListener('focus', function () {
          _this4.setVisualFocusOn(_this4.searchAreaElement);
        });
        this.inputElement.addEventListener('keydown', function (event) {
          if (_this4.isComponentReadOnly()) {
            return;
          }
          var altKey = event.altKey;
          var preventDefault = false;
          var length = _this4.inputElement.value.length;
          switch (event.code) {
            case 'Enter':
              if (_this4.visualFocusOnAvailableItems()) {
                var currentItemElement = _this4.getAvailableItemActiveDescendant();
                if (currentItemElement !== false) {
                  if (!_this4.isAvailableItemDisabled(currentItemElement)) {
                    if (_this4.isAvailableItemSelected(currentItemElement)) {
                      _this4.removeAvailableItem(currentItemElement);
                    } else {
                      _this4.selectAvailableItem(currentItemElement);
                    }
                  }
                }
              } else {
                if (!_this4.isAvailableItemsOpen()) {
                  _this4.filterAvailableItems();
                  _this4.openAvailableItems();
                }
                _this4.setVisualFocusOn(_this4.availableItemsListElement);
                _this4.setAvailableItemActiveDescendant(_this4.getFirstAvailableItem());
                _this4.scrollActiveAvailableItemInView();
              }
              preventDefault = true;
              break;
            case 'Down':
            case 'ArrowDown':
              if (altKey) {
                if (!_this4.isAvailableItemsOpen()) {
                  _this4.filterAvailableItems();
                  _this4.openAvailableItems();
                }
              } else {
                if (!_this4.isAvailableItemsOpen()) {
                  _this4.filterAvailableItems();
                  _this4.openAvailableItems();
                }
                if (!_this4.visualFocusOnAvailableItems()) {
                  _this4.setVisualFocusOn(_this4.availableItemsListElement);
                  _this4.setAvailableItemActiveDescendant(_this4.getFirstAvailableItem());
                  _this4.scrollActiveAvailableItemInView();
                } else {
                  _this4.setVisualFocusOn(_this4.availableItemsListElement);
                  _this4.setAvailableItemActiveDescendant(_this4.getNextAvailableItem());
                  _this4.scrollActiveAvailableItemInView();
                }
              }
              preventDefault = true;
              break;
            case 'Esc':
            case 'Escape':
              if (_this4.isAvailableItemsOpen()) {
                _this4.closeAvailableItems(true);
                _this4.setVisualFocusOn(_this4.searchAreaElement);
              }
              preventDefault = true;
              break;
            case 'Up':
            case 'ArrowUp':
              if (altKey) {
                if (!_this4.isAvailableItemsOpen()) {
                  _this4.filterAvailableItems();
                  _this4.openAvailableItems();
                }
              } else {
                if (!_this4.isAvailableItemsOpen()) {
                  _this4.filterAvailableItems();
                  _this4.openAvailableItems();
                }
                if (!_this4.visualFocusOnAvailableItems()) {
                  _this4.setVisualFocusOn(_this4.availableItemsListElement);
                  _this4.setAvailableItemActiveDescendant(_this4.getLastAvailableItem());
                  _this4.scrollActiveAvailableItemInView();
                } else {
                  _this4.setVisualFocusOn(_this4.availableItemsListElement);
                  _this4.setAvailableItemActiveDescendant(_this4.getPreviousAvailableItem());
                  _this4.scrollActiveAvailableItemInView();
                }
              }
              preventDefault = true;
              break;
            case 'Tab':
              _this4.closeAvailableItems(true);
              _this4.setVisualFocusOn(false);
              break;
            case 'Home':
              _this4.inputElement.setSelectionRange(_dcfUtility.DCFUtility.magicNumbers('int0'), _dcfUtility.DCFUtility.magicNumbers('int0'));
              preventDefault = true;
              break;
            case 'End':
              _this4.inputElement.setSelectionRange(length, length);
              preventDefault = true;
              break;
            default:
              break;
          }
          if (preventDefault) {
            event.stopPropagation();
            event.preventDefault();
          }
        });
        this.inputElement.addEventListener('keyup', function (event) {
          if (_this4.isComponentReadOnly()) {
            return;
          }
          var _char = event.key;
          // const altKey = event.altKey;
          var preventDefault = false;
          // const length = this.inputElement.value.length;

          if (event.key === 'Escape' || event.key === 'Esc') {
            return;
          }
          switch (event.code) {
            case 'Backspace':
              _this4.setVisualFocusOn(_this4.searchAreaElement);
              _this4.filterAvailableItems();
              _this4.setAvailableItemActiveDescendant(false);
              preventDefault = true;
              break;
            case 'Left':
            case 'ArrowLeft':
            case 'Right':
            case 'ArrowRight':
            case 'Home':
            case 'End':
              _this4.setVisualFocusOn(_this4.searchAreaElement);
              preventDefault = true;
              break;
            default:
              if (_this4.isPrintableCharacter(_char)) {
                _this4.setVisualFocusOn(_this4.searchAreaElement);
                _this4.filterAvailableItems();
                _this4.openAvailableItems();
                _this4.setAvailableItemActiveDescendant(false);
              }
              break;
          }
          if (preventDefault) {
            event.stopPropagation();
            event.preventDefault();
          }
        });
        this.availableItemsListElement.addEventListener('click', function (event) {
          var closestItem = event.target.closest('.dcf-search-and-select-available-item');
          if (closestItem === null) {
            return;
          }

          // If an item is disabled you can not select or de-select
          if (!_this4.isAvailableItemDisabled(closestItem)) {
            if (_this4.isAvailableItemSelected(closestItem)) {
              _this4.removeAvailableItem(closestItem);
            } else {
              _this4.selectAvailableItem(closestItem);
            }
          }
          _this4.inputElement.focus();
          _this4.setVisualFocusOn(_this4.availableItemsListElement);
          _this4.setAvailableItemActiveDescendant(closestItem);
        });
        this.availableItemsListElement.addEventListener('pointermove', function (event) {
          var currentItem = _this4.getAvailableItemActiveDescendant();
          var closestItem = event.target.closest('.dcf-search-and-select-available-item');
          if (closestItem === null) {
            return;
          }
          if (currentItem === false || !closestItem.isSameNode(currentItem)) {
            _this4.setAvailableItemActiveDescendant(closestItem);
          }
        });
        this.availableItemsListElement.addEventListener('pointerout', function (event) {
          if (_this4.availableItemsListElement.isSameNode(event.target)) {
            _this4.setAvailableItemActiveDescendant(false);
          }
        });
      }

      /**
       * Will turn the component's disabled mode on or off
       * @param { bool } boolDisabled the new disabled state
       */
    }, {
      key: "setDisabled",
      value: function setDisabled(boolDisabled) {
        var formattedBoolDisabled = boolDisabled;
        if (typeof formattedBoolDisabled !== 'boolean') {
          formattedBoolDisabled = false;
        }
        if (formattedBoolDisabled) {
          this.inputElement.setAttribute('disabled', 'disabled');
          this.openButtonElement.setAttribute('disabled', 'disabled');
          this.searchAndSelectElement.classList.add('dcf-search-and-select-disabled');
          this.setVisualFocusOn(false);
          this.closeAvailableItems();
        } else {
          this.inputElement.removeAttribute('disabled');
          this.openButtonElement.removeAttribute('disabled');
          this.searchAndSelectElement.classList.remove('dcf-search-and-select-disabled');
        }
      }

      /**
       * Determines if the component is in disabled mode
       * @returns { bool } true if the component is disabled
       */
    }, {
      key: "isComponentDisabled",
      value: function isComponentDisabled() {
        return this.inputElement.getAttribute('disabled') !== null;
      }

      /**
       * Will turn the component's readonly mode on or off
       * @param { bool } boolReadOnly the new readonly state
       */
    }, {
      key: "setReadOnly",
      value: function setReadOnly(boolReadOnly) {
        var formattedBoolReadOnly = boolReadOnly;
        if (typeof formattedBoolReadOnly !== 'boolean') {
          formattedBoolReadOnly = false;
        }
        if (formattedBoolReadOnly) {
          this.inputElement.setAttribute('readonly', 'readonly');
          this.openButtonElement.setAttribute('readonly', 'readonly');
          this.closeAvailableItems();
        } else {
          this.inputElement.removeAttribute('readonly');
          this.openButtonElement.removeAttribute('readonly');
        }
      }

      /**
       * Determines if the component is in readonly mode
       * @returns { bool } true if the component is readonly
       */
    }, {
      key: "isComponentReadOnly",
      value: function isComponentReadOnly() {
        return this.inputElement.getAttribute('readonly') !== null;
      }

      /**
       * Determines if the keyboard input was a printable character or not
       * @param { string } str string to test
       * @returns { bool } true if the string was a printable character
       */
    }, {
      key: "isPrintableCharacter",
      value: function isPrintableCharacter(str) {
        return str.length === _dcfUtility.DCFUtility.magicNumbers('int1') && str.match(/\S| /);
      }

      /**
       * Determines if the available items list is expanded or not
       * @returns { bool } true if the available items list is expanded
       */
    }, {
      key: "isAvailableItemsOpen",
      value: function isAvailableItemsOpen() {
        return !this.availableItemsListElement.classList.contains('dcf-d-none');
      }

      /**
       * Handles functionality of opening/expanding the available items list
       */
    }, {
      key: "openAvailableItems",
      value: function openAvailableItems() {
        this.inputElement.setAttribute('aria-expanded', 'true');
        this.openButtonElement.setAttribute('aria-expanded', 'true');
        this.availableItemsListElement.classList.remove('dcf-d-none');
      }

      /**
       * Handles functionality of closing/un-expanding the available items list
       */
    }, {
      key: "closeAvailableItems",
      value: function closeAvailableItems() {
        this.inputElement.setAttribute('aria-expanded', 'false');
        this.openButtonElement.setAttribute('aria-expanded', 'false');
        this.availableItemsListElement.classList.add('dcf-d-none');
      }

      /**
       * Determines if the visual focus is on the available items list
       * @returns { bool } true if the available items list has visual focus
       */
    }, {
      key: "visualFocusOnAvailableItems",
      value: function visualFocusOnAvailableItems() {
        return this.availableItemsListElement.dataset.focused === 'true';
      }

      /**
       * Handles functionality of how to set the visual focus on an element
       * @param { HTMLElement|false } elementToFocus The element to focus on or false to not focus on anything
       */
    }, {
      key: "setVisualFocusOn",
      value: function setVisualFocusOn(elementToFocus) {
        // Un-set the current focused element if there is any
        if (this.currentFocus !== null && this.availableItemsListElement.isSameNode(this.currentFocus)) {
          this.searchAreaElement.classList.remove('dcf-search-and-select-visual-focus');
          delete this.availableItemsListElement.dataset.focused;
        } else if (this.currentFocus !== null) {
          this.currentFocus.classList.remove('dcf-search-and-select-visual-focus');
          delete this.currentFocus.dataset.focused;
        }

        // Set the focus on the new element or do nothing if false
        if (elementToFocus !== false && this.availableItemsListElement.isSameNode(elementToFocus)) {
          this.searchAreaElement.classList.add('dcf-search-and-select-visual-focus');
          this.availableItemsListElement.dataset.focused = 'true';
          this.currentFocus = elementToFocus;
        } else if (elementToFocus !== false) {
          elementToFocus.classList.add('dcf-search-and-select-visual-focus');
          elementToFocus.dataset.focused = 'true';
          this.currentFocus = elementToFocus;
        } else {
          this.currentFocus = null;
        }
      }

      /**
       * Handles functionality of how to set the visual hover on an element
       * @param { HTMLElement|false } elementToHover The element to hover on or false to not hover on anything
       */
    }, {
      key: "setVisualHover",
      value: function setVisualHover(elementToHover) {
        // Un-set hover on anything inside the component
        this.searchAndSelectElement.querySelectorAll('.dcf-search-and-select-visual-hover').forEach(function (elem) {
          elem.classList.remove('dcf-search-and-select-visual-hover');
        });

        // Set the hover on element or do nothing on false
        if (elementToHover !== false) {
          elementToHover.classList.add('dcf-search-and-select-visual-hover');
          this.currentHover = elementToHover;
        } else {
          this.currentHover = null;
        }
      }

      /**
       * Gets the currently active item in the available items list
       * @returns { HTMLLIElement|false } The currently active element in the available items list or false if there is none
       */
    }, {
      key: "getAvailableItemActiveDescendant",
      value: function getAvailableItemActiveDescendant() {
        var currentItemID = this.inputElement.getAttribute('aria-activedescendant');
        if (currentItemID !== null && currentItemID !== '') {
          var currentItemElement = document.getElementById(currentItemID);
          if (currentItemElement !== null) {
            return currentItemElement;
          }
        }
        return false;
      }

      /**
       * Handles functionality of setting the active element on the available items list
       * @param { HTMLLIElement|false } itemToSet The list item to set or false if there is none
       */
    }, {
      key: "setAvailableItemActiveDescendant",
      value: function setAvailableItemActiveDescendant(itemToSet) {
        if (itemToSet !== false && !this.isElementAnAvailableItem(itemToSet)) {
          throw new Error('Element is not an available item');
        }
        if (itemToSet !== false) {
          this.inputElement.setAttribute('aria-activedescendant', itemToSet.getAttribute('id'));
          this.setVisualHover(itemToSet);
        } else {
          this.setVisualHover(false);
          this.inputElement.setAttribute('aria-activedescendant', '');
        }
      }

      /**
       * Handles functionality of scrolling the current active item into view
       */
    }, {
      key: "scrollActiveAvailableItemInView",
      value: function scrollActiveAvailableItemInView() {
        var currentItemElement = this.getAvailableItemActiveDescendant();
        if (currentItemElement !== false && !this.isAvailableItemInView(currentItemElement)) {
          currentItemElement.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest'
          });
        }
      }

      /**
       * Gets the next available item that is currently being shown
       * This will loop the beginning if we are at the end of the list
       * @returns { HTMLLIElement|null } The next shown available item or null if there is none
       */
    }, {
      key: "getNextAvailableItem",
      value: function getNextAvailableItem() {
        var nextElement = null;
        var nextElementFlag = false;
        for (var index = 0; index < this.listOfAvailableItems.length; index++) {
          if (nextElementFlag) {
            nextElement = this.listOfAvailableItems[index];
            break;
          }
          if (this.listOfAvailableItems[index].getAttribute('id') === this.inputElement.getAttribute('aria-activedescendant')) {
            nextElementFlag = true;
          }
        }
        if (nextElement === null) {
          return this.getFirstAvailableItem();
        }
        return nextElement;
      }

      /**
       * Gets the previous available item that is currently being shown
       * This will loop to the end if we are the beginning of the list
       * @returns { HTMLLIElement|null } The previous shown available item or null if there is none
       */
    }, {
      key: "getPreviousAvailableItem",
      value: function getPreviousAvailableItem() {
        var previousElement = null;
        for (var index = 0; index < this.listOfAvailableItems.length; index++) {
          if (this.listOfAvailableItems[index].getAttribute('id') === this.inputElement.getAttribute('aria-activedescendant')) {
            break;
          }
          previousElement = this.listOfAvailableItems[index];
        }
        if (previousElement === null) {
          return this.getLastAvailableItem();
        }
        return previousElement;
      }

      /**
       * Gets the first available item that is currently being shown
       * @returns { HTMLLIElement|null } The first shown available item or null if there is none
       */
    }, {
      key: "getFirstAvailableItem",
      value: function getFirstAvailableItem() {
        if (this.listOfAvailableItems.length === _dcfUtility.DCFUtility.magicNumbers('int0')) {
          return false;
        }
        return this.listOfAvailableItems[_dcfUtility.DCFUtility.magicNumbers('int0')];
      }

      /**
       * Gets the last available item that is currently being shown
       * @returns { HTMLLIElement|null } The last shown available item or null if there is none
       */
    }, {
      key: "getLastAvailableItem",
      value: function getLastAvailableItem() {
        if (this.listOfAvailableItems.length === _dcfUtility.DCFUtility.magicNumbers('int0')) {
          return false;
        }
        return this.listOfAvailableItems[this.listOfAvailableItems.length - _dcfUtility.DCFUtility.magicNumbers('int1')];
      }

      /**
       * Handles the functionality of selecting an available item
       * @param { HTMLLIElement } itemToSelect The available item to select
       */
    }, {
      key: "selectAvailableItem",
      value: function selectAvailableItem(itemToSelect) {
        if (!this.isElementAnAvailableItem(itemToSelect)) {
          throw new Error('Element is not an available item');
        }
        var allItems = this.availableItemsListElement.querySelectorAll('li.dcf-search-and-select-available-item');
        allItems.forEach(function (singleOption) {
          singleOption.setAttribute('aria-selected', 'false');
        });
        itemToSelect.setAttribute('aria-selected', 'true');
        this.selectElement.querySelectorAll('option').forEach(function (singleOption) {
          if (singleOption.value === itemToSelect.dataset.value) {
            singleOption.setAttribute('selected', 'selected');
          } else {
            singleOption.removeAttribute('selected', 'selected');
          }
        });
        this.closeAvailableItems();
        this.inputElement.value = itemToSelect.dataset.label;
      }

      /**
       * Handles the functionality of de-selecting an available item
       * @param { HTMLLIElement } itemToRemove The available item to de-select
       */
    }, {
      key: "removeAvailableItem",
      value: function removeAvailableItem(itemToRemove) {
        if (!this.isElementAnAvailableItem(itemToRemove)) {
          throw new Error('Element is not an available item');
        }
        itemToRemove.setAttribute('aria-selected', 'false');
        this.selectElement.querySelectorAll('option').forEach(function (singleOption) {
          if (singleOption.value === itemToRemove.dataset.value) {
            singleOption.removeAttribute('selected');
          }
        });
        this.inputElement.value = '';
        this.filterAvailableItems();
      }

      /**
       * Checks if the element has the class `dcf-search-and-select-available-item`
       * @param { HTMLElement } elementToCheck The element to check
       * @returns { bool } true if it does contain that class
       */
    }, {
      key: "isElementAnAvailableItem",
      value: function isElementAnAvailableItem(elementToCheck) {
        return elementToCheck.classList.contains('dcf-search-and-select-available-item');
      }

      /**
       * Checks if the available item is selected
       * @param { HTMLLIElement } itemToCheck The item to check if it is selected
       * @returns { bool } true if the item is selected
       */
    }, {
      key: "isAvailableItemSelected",
      value: function isAvailableItemSelected(itemToCheck) {
        if (!this.isElementAnAvailableItem(itemToCheck)) {
          throw new Error('Element is not an available item');
        }
        return itemToCheck.getAttribute('aria-selected') === 'true';
      }

      /**
       * Checks if the available item is disabled
       * @param { HTMLLIElement } itemToCheck The item to check if it is disabled
       * @returns { bool } true if the item is disabled
       */
    }, {
      key: "isAvailableItemDisabled",
      value: function isAvailableItemDisabled(itemToCheck) {
        if (!this.isElementAnAvailableItem(itemToCheck)) {
          throw new Error('Element is not an available item');
        }
        return itemToCheck.getAttribute('aria-disabled') === 'true';
      }

      /**
       * Calculates if the available item is in view
       * @param { HTMLLIElement } itemToCheck The item to check if it is in view
       * @returns { bool } true if it is in view
       */
    }, {
      key: "isAvailableItemInView",
      value: function isAvailableItemInView(itemToCheck) {
        if (!this.isElementAnAvailableItem(itemToCheck)) {
          throw new Error('Element is not an available item');
        }

        // Get the bounding client rect of the ul and li
        var listRect = this.availableItemsListElement.getBoundingClientRect();
        var itemToCheckRect = itemToCheck.getBoundingClientRect();

        // Check if the li is vertically in view within the ul
        return itemToCheckRect.top >= listRect.top && itemToCheckRect.bottom <= listRect.bottom;
      }

      /**
       * Filters available items and hides any item that does not contain the input value's string
       */
    }, {
      key: "filterAvailableItems",
      value: function filterAvailableItems() {
        var _this5 = this;
        var searchTerm = this.inputElement.value.trim().toUpperCase();
        var allItems = this.availableItemsListElement.querySelectorAll('li.dcf-search-and-select-available-item');
        var allItemGroups = this.availableItemsListElement.querySelectorAll('.dcf-search-and-select-available-items-group');
        this.listOfAvailableItems = [];

        // Removes any no results elements
        this.availableItemsListElement.querySelectorAll('.dcf-search-and-select-no-results').forEach(function (singleNoResult) {
          singleNoResult.remove();
        });
        var noItemsFound = true;
        allItems.forEach(function (singleItem) {
          var itemLabel = singleItem.querySelector('.dcf-search-and-select-available-item-label').innerText.toUpperCase();
          if (searchTerm === '' || itemLabel.includes(searchTerm)) {
            singleItem.classList.remove('dcf-d-none');
            singleItem.classList.add('dcf-d-flex');
            _this5.listOfAvailableItems.push(singleItem);
            noItemsFound = false;
          } else {
            singleItem.classList.add('dcf-d-none');
            singleItem.classList.remove('dcf-d-flex');
          }
        });
        allItemGroups.forEach(function (singleGroup) {
          var shownGroupItems = singleGroup.querySelectorAll('.dcf-search-and-select-available-item:not(.dcf-d-none)');
          if (shownGroupItems.length === _dcfUtility.DCFUtility.magicNumbers('int0')) {
            singleGroup.classList.add('dcf-d-none');
          } else {
            singleGroup.classList.remove('dcf-d-none');
          }
        });

        // if there were no items found it will add a note about no items being found
        if (noItemsFound) {
          var _noItemsFoundElement$;
          var noItemsFoundElement = document.createElement('ul');
          noItemsFoundElement.setAttribute('role', 'presentation');
          (_noItemsFoundElement$ = noItemsFoundElement.classList).add.apply(_noItemsFoundElement$, ['dcf-search-and-select-no-results'].concat(_toConsumableArray(this.theme.availableItemsGroupClassList)));
          noItemsFoundElement.innerHTML = "\n        <li class=\"".concat(this.theme.availableItemsNoResultsClassList.join(' '), "\" role=\"option\">\n          No results found\n        </li>\n      ");
          this.availableItemsListElement.append(noItemsFoundElement);
        }
      }
    }]);
    return DCFSearchSelectSingle;
  }();
  /** This is the class for a single instance of a multi-select combobox */
  // eslint-disable-next-line padded-blocks
  var DCFSearchSelectMultiple = /*#__PURE__*/function (_DCFSearchSelectSingl) {
    _inherits(DCFSearchSelectMultiple, _DCFSearchSelectSingl);
    var _super = _createSuper(DCFSearchSelectMultiple);
    /**
     * Constructor for the multi-select combobox
     * @param { HTMLSelectElement } selectElement The select that will be used to build the component
     * @param { DCFSearchSelectTheme | null } theme The theme to be used to build the component
     */
    function DCFSearchSelectMultiple(selectElement) {
      var _this6$searchAndSelec;
      var _this6;
      var theme = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      _classCallCheck(this, DCFSearchSelectMultiple);
      _this6 = _super.call(this, selectElement, theme);
      _this6.selectedItemsListID = _this6.uuid.concat('-search-and-select-selected-items-list');
      _this6.selectedItemsHelpID = _this6.uuid.concat('-search-and-select-selected-items-list-help');

      // This is the core markup for the component
      _this6.searchAndSelectElement = document.createElement('div');
      _this6.searchAndSelectElement.innerHTML = "\n      <div class=\"dcf-search-and-select-search-area-multiple ".concat(_this6.theme.searchAreaClassList.join(' '), "\" >\n        <div class=\"dcf-search-and-select-multiple-input-group ").concat(_this6.theme.inputGroupMultiple.join(' '), "\">\n          <span id=\"").concat(_this6.selectedItemsHelpID, "\" class=\"dcf-sr-only\">Press Delete or Backspace to Remove.</span>\n          <ul\n            class=\"dcf-search-and-select-selected-items ").concat(_this6.theme.selectedItemsListClassList.join(' '), "\"\n            role=\"list\"\n            aria-describedby=\"").concat(_this6.selectedItemsHelpID, "\"\n            id=").concat(_this6.selectedItemsListID, "\n            aria-label=\"Selected Items\"\n          ></ul>\n          <input\n            class=\"").concat(_this6.theme.inputMultipleClassList.join(' '), "\"\n            type=\"text\"\n            role=\"combobox\"\n            id=").concat(_this6.inputID, "\n            aria-haspopup=\"listbox\"\n            aria-autocomplete=\"list\"\n            aria-expanded=\"false\"\n            aria-controls=\"").concat(_this6.availableItemsListID, "\"\n          >\n        </div>\n        <div class=\"dcf-search-and-select-open-btn ").concat(_this6.theme.toggleButtonContainerClassList.join(' '), "\">\n          <button\n            class=\"").concat(_this6.theme.toggleButtonClassList.join(' '), "\"\n            type=\"button\"\n            tabindex=\"-1\"\n            aria-label=\"Toggle Selectable List\"\n            aria-expanded=\"false\"\n            aria-controls=\"").concat(_this6.availableItemsListID, "\"\n          >\n            ").concat(_this6.theme.toggleButtonSVG, "\n          </button>\n        </div>\n\n      </div>\n    ");
      (_this6$searchAndSelec = _this6.searchAndSelectElement.classList).add.apply(_this6$searchAndSelec, ['dcf-search-and-select'].concat(_toConsumableArray(_this6.theme.searchAndSelectClassList)));
      _this6.searchAndSelectElement.setAttribute('id', _this6.searchAndSelectID);
      _this6.searchAndSelectElement.setAttribute('hidden', 'hidden'); // This will be removed later in the constructor
      _this6.searchAndSelectElement.dataset.for = _this6.selectID;

      // We will select the items for use in the rest of the component
      _this6.inputElement = _this6.searchAndSelectElement.querySelector('input');
      _this6.selectedItemsListElement = _this6.searchAndSelectElement.querySelector('.dcf-search-and-select-selected-items');
      _this6.openButtonElement = _this6.searchAndSelectElement.querySelector('.dcf-search-and-select-open-btn button');
      _this6.searchAreaElement = _this6.searchAndSelectElement.querySelector('.dcf-search-and-select-search-area-multiple');

      // We will parse the select element and build the available items from that
      _this6.parsedSelect = _this6.parseSelect();
      return _this6;
    }

    /**
     * This will use the values from the constructors
     * This is needed due to the extends on the multi
     */
    _createClass(DCFSearchSelectMultiple, [{
      key: "init",
      value: function init() {
        _get(_getPrototypeOf(DCFSearchSelectMultiple.prototype), "init", this).call(this);
        this.availableItemsListElement.setAttribute('aria-multiselectable', true);
      }

      /**
       * Builds the available items UL from output of parse select
       * @returns { HTMLUListElement }
       */
    }, {
      key: "buildAvailableItems",
      value: function buildAvailableItems() {
        var _this7 = this;
        var availableItems = document.createElement('ul');
        availableItems.setAttribute('role', 'listbox');
        this.parsedSelect.forEach(function (singleOptgroup) {
          var _groupedItems$classLi2;
          var groupedItems = document.createElement('ul');
          groupedItems.setAttribute('role', 'group');
          (_groupedItems$classLi2 = groupedItems.classList).add.apply(_groupedItems$classLi2, ['dcf-search-and-select-available-items-group'].concat(_toConsumableArray(_this7.theme.availableItemsGroupClassList)));
          if (_this7.parsedSelect.length !== _dcfUtility.DCFUtility.magicNumbers('int1')) {
            groupedItems.innerHTML = "\n        ".concat(groupedItems.innerHTML, "\n        <li\n          class=\"").concat(_this7.theme.availableItemsGroupLabelClassList.join(' '), "\"\n          role=\"presentation\"\n        >\n          ").concat(singleOptgroup.label, "\n        </li>\n      ");
          }
          singleOptgroup.items.forEach(function (singleItem) {
            var _newItem$classList2;
            var newItem = document.createElement('li');
            (_newItem$classList2 = newItem.classList).add.apply(_newItem$classList2, ['dcf-search-and-select-available-item', 'dcf-search-and-select-clickable'].concat(_toConsumableArray(_this7.theme.availableItemClassList)));
            newItem.setAttribute('role', 'option');
            newItem.setAttribute('aria-selected', singleItem.disabled ? 'false' : singleItem.selected);
            newItem.setAttribute('aria-disabled', singleItem.disabled);
            newItem.setAttribute('id', "".concat(singleItem.id, "-available"));
            newItem.dataset.value = singleItem.value;
            newItem.dataset.id = singleItem.id;
            newItem.innerHTML = "\n          <span class=\"dcf-search-and-select-available-item-label\">\n            ".concat(singleItem.label, "\n          </span>\n          <span class=\"dcf-search-and-select-available-item-indicator\" aria-hidden=\"true\">\n            ").concat(_this7.theme.availableItemIndicatorSVG, "\n          </span>\n        ");
            groupedItems.append(newItem);

            // We need to add the selected options into the selected items list
            if (singleItem.disabled === false && singleItem.selected === true) {
              _this7.appendNewSelectedItem(newItem);
            }
          });
          availableItems.append(groupedItems);
        });
        return availableItems;
      }

      /**
       * We will build a new selected item element and append it to the list of selected items
       * @param { HTMLLIElement } singleAvailableItem The li from the available items list
       */
    }, {
      key: "appendNewSelectedItem",
      value: function appendNewSelectedItem(singleAvailableItem) {
        var _newSelectedItem$clas;
        if (!this.isElementAnAvailableItem(singleAvailableItem)) {
          throw new Error('Element is not an available item');
        }
        var selectedItemLabel = singleAvailableItem.querySelector('.dcf-search-and-select-available-item-label').innerText;
        var newSelectedItem = document.createElement('li');
        newSelectedItem.dataset.id = singleAvailableItem.dataset.id;
        newSelectedItem.setAttribute('id', "".concat(singleAvailableItem.dataset.id, "-selected"));
        (_newSelectedItem$clas = newSelectedItem.classList).add.apply(_newSelectedItem$clas, ['dcf-search-and-select-selected-item', 'dcf-search-and-select-clickable'].concat(_toConsumableArray(this.theme.selectedItemClassList)));
        newSelectedItem.innerHTML = "\n      <button\n        class=\"\n          dcf-search-and-select-selected-item-remove-btn\n          ".concat(this.theme.selectedItemButtonClassList.join(' '), "\n        \"\n        type=\"button\"\n        aria-label=\"Remove ").concat(selectedItemLabel, "\"\n      >\n        ").concat(this.theme.selectedItemButtonSVG, "\n      </button>\n      <span class=\"\n        dcf-search-and-select-selected-item-label\n        ").concat(this.theme.selectedItemLabelClassList.join(' '), "\">\n        ").concat(selectedItemLabel, "\n      </span>\n    ");
        this.selectedItemsListElement.append(newSelectedItem);

        // If the item is not in view then we will scroll it into view
        if (!this.isSelectedItemInView(newSelectedItem)) {
          newSelectedItem.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest'
          });
        }
      }

      /**
       * Add event listeners for the different parts of the search and select element
       */
    }, {
      key: "addEventListeners",
      value: function addEventListeners() {
        var _this8 = this;
        // This is for when we click outside the component
        document.body.addEventListener('pointerup', function (event) {
          if (!_this8.searchAndSelectElement.contains(event.target)) {
            _this8.closeAvailableItems();
            _this8.setVisualFocusOn(false);
          }
        }, true);
        this.searchAreaElement.addEventListener('click', function () {
          if (_this8.isComponentDisabled()) {
            return;
          }
          _this8.setVisualFocusOn(_this8.searchAreaElement);
          _this8.inputElement.focus();
          if (_this8.isAvailableItemsOpen() || _this8.isComponentReadOnly()) {
            _this8.closeAvailableItems();
          } else {
            _this8.filterAvailableItems();
            _this8.openAvailableItems();
          }
        });
        this.inputElement.addEventListener('focus', function () {
          _this8.setVisualFocusOn(_this8.searchAreaElement);
        });
        this.inputElement.addEventListener('keydown', function (event) {
          if (_this8.isComponentReadOnly()) {
            return;
          }
          var altKey = event.altKey;
          var shiftKey = event.shiftKey;
          var preventDefault = false;
          var length = _this8.inputElement.value.length;
          switch (event.code) {
            case 'Enter':
              if (_this8.visualFocusOnAvailableItems()) {
                var currentItemElement = _this8.getAvailableItemActiveDescendant();
                if (currentItemElement !== false) {
                  if (!_this8.isAvailableItemDisabled(currentItemElement)) {
                    if (_this8.isAvailableItemSelected(currentItemElement)) {
                      _this8.removeAvailableItem(currentItemElement);
                    } else {
                      _this8.selectAvailableItem(currentItemElement);
                    }
                  }
                }
              } else {
                if (!_this8.isAvailableItemsOpen()) {
                  _this8.filterAvailableItems();
                  _this8.openAvailableItems();
                }
                _this8.setVisualFocusOn(_this8.availableItemsListElement);
                _this8.setAvailableItemActiveDescendant(_this8.getFirstAvailableItem());
                _this8.scrollActiveAvailableItemInView();
              }
              preventDefault = true;
              break;
            case 'Down':
            case 'ArrowDown':
              if (altKey) {
                if (!_this8.isAvailableItemsOpen()) {
                  _this8.filterAvailableItems();
                  _this8.openAvailableItems();
                }
              } else {
                if (!_this8.isAvailableItemsOpen()) {
                  _this8.filterAvailableItems();
                  _this8.openAvailableItems();
                }
                if (!_this8.visualFocusOnAvailableItems()) {
                  _this8.setVisualFocusOn(_this8.availableItemsListElement);
                  _this8.setAvailableItemActiveDescendant(_this8.getFirstAvailableItem());
                  _this8.scrollActiveAvailableItemInView();
                } else {
                  _this8.setVisualFocusOn(_this8.availableItemsListElement);
                  _this8.setAvailableItemActiveDescendant(_this8.getNextAvailableItem());
                  _this8.scrollActiveAvailableItemInView();
                }
              }
              preventDefault = true;
              break;
            case 'Esc':
            case 'Escape':
              if (_this8.isAvailableItemsOpen()) {
                _this8.closeAvailableItems(true);
                _this8.setVisualFocusOn(_this8.searchAreaElement);
              }
              preventDefault = true;
              break;
            case 'Up':
            case 'ArrowUp':
              if (altKey) {
                if (!_this8.isAvailableItemsOpen()) {
                  _this8.filterAvailableItems();
                  _this8.openAvailableItems();
                }
              } else {
                if (!_this8.isAvailableItemsOpen()) {
                  _this8.filterAvailableItems();
                  _this8.openAvailableItems();
                }
                if (!_this8.visualFocusOnAvailableItems()) {
                  _this8.setVisualFocusOn(_this8.availableItemsListElement);
                  _this8.setAvailableItemActiveDescendant(_this8.getLastAvailableItem());
                  _this8.scrollActiveAvailableItemInView();
                } else {
                  _this8.setVisualFocusOn(_this8.availableItemsListElement);
                  _this8.setAvailableItemActiveDescendant(_this8.getPreviousAvailableItem());
                  _this8.scrollActiveAvailableItemInView();
                }
              }
              preventDefault = true;
              break;
            case 'Tab':
              _this8.closeAvailableItems(true);
              if (!shiftKey) {
                _this8.setVisualFocusOn(false);
              }
              break;
            case 'Home':
              _this8.inputElement.setSelectionRange(_dcfUtility.DCFUtility.magicNumbers('int0'), _dcfUtility.DCFUtility.magicNumbers('int0'));
              preventDefault = true;
              break;
            case 'End':
              _this8.inputElement.setSelectionRange(length, length);
              preventDefault = true;
              break;
            default:
              break;
          }
          if (preventDefault) {
            event.stopPropagation();
            event.preventDefault();
          }
        });
        this.inputElement.addEventListener('keyup', function (event) {
          if (_this8.isComponentReadOnly()) {
            return;
          }
          var _char2 = event.key;
          // const altKey = event.altKey;
          var preventDefault = false;
          // const length = this.inputElement.value.length;

          if (event.key === 'Escape' || event.key === 'Esc') {
            return;
          }
          switch (event.code) {
            case 'Backspace':
              _this8.setVisualFocusOn(_this8.searchAreaElement);
              _this8.filterAvailableItems();
              _this8.setAvailableItemActiveDescendant(false);
              preventDefault = true;
              break;
            case 'Left':
            case 'ArrowLeft':
            case 'Right':
            case 'ArrowRight':
            case 'Home':
            case 'End':
              _this8.setVisualFocusOn(_this8.searchAreaElement);
              preventDefault = true;
              break;
            default:
              if (_this8.isPrintableCharacter(_char2)) {
                _this8.setVisualFocusOn(_this8.searchAreaElement);
                _this8.filterAvailableItems();
                _this8.openAvailableItems();
                _this8.setAvailableItemActiveDescendant(false);
              }
              break;
          }
          if (preventDefault) {
            event.stopPropagation();
            event.preventDefault();
          }
        });
        this.availableItemsListElement.addEventListener('click', function (event) {
          var closestItem = event.target.closest('.dcf-search-and-select-available-item');
          if (closestItem === null) {
            return;
          }

          // If an item is disabled you can not select or de-select
          if (!_this8.isAvailableItemDisabled(closestItem)) {
            if (_this8.isAvailableItemSelected(closestItem)) {
              _this8.removeAvailableItem(closestItem);
            } else {
              _this8.selectAvailableItem(closestItem);
            }
          }
          _this8.inputElement.focus();
          _this8.setVisualFocusOn(_this8.availableItemsListElement);
          _this8.setAvailableItemActiveDescendant(closestItem);
        });
        this.availableItemsListElement.addEventListener('pointermove', function (event) {
          var currentItem = _this8.getAvailableItemActiveDescendant();
          var closestItem = event.target.closest('.dcf-search-and-select-available-item');
          if (closestItem === null) {
            return;
          }
          if (currentItem === false || !closestItem.isSameNode(currentItem)) {
            _this8.setAvailableItemActiveDescendant(closestItem);
          }
        });
        this.availableItemsListElement.addEventListener('pointerout', function (event) {
          if (_this8.availableItemsListElement.isSameNode(event.target)) {
            _this8.setAvailableItemActiveDescendant(false);
          }
        });
        this.selectedItemsListElement.addEventListener('focus', function () {
          _this8.setVisualFocusOn(false);
        });
        this.selectedItemsListElement.addEventListener('click', function (event) {
          if (_this8.isComponentDisabled()) {
            return;
          }
          var closestSelectedItem = event.target.closest('.dcf-search-and-select-selected-item');
          if (closestSelectedItem === null) {
            return;
          }
          var closestDeleteButton = event.target.closest('.dcf-search-and-select-selected-item-remove-btn');
          if (closestDeleteButton !== null && !_this8.isComponentReadOnly()) {
            _this8.selectedItemsListElement.focus();
            _this8.removeSelectedItem(closestSelectedItem);
            _this8.setAvailableItemActiveDescendant(false);
            event.stopPropagation();
            return;
          }
          event.stopPropagation();
        });
      }

      /**
       * Will turn the component's disabled mode on or off
       * @param { bool } boolDisabled the new disabled state
       */
    }, {
      key: "setDisabled",
      value: function setDisabled(boolDisabled) {
        var formattedBoolDisabled = boolDisabled;
        if (typeof formattedBoolDisabled !== 'boolean') {
          formattedBoolDisabled = false;
        }
        if (formattedBoolDisabled) {
          this.inputElement.setAttribute('disabled', 'disabled');
          this.openButtonElement.setAttribute('disabled', 'disabled');
          this.searchAndSelectElement.classList.add('dcf-search-and-select-disabled');
          this.selectedItemsListElement.setAttribute('aria-disabled', 'true');
          this.selectedItemsListElement.querySelectorAll('button').forEach(function (selectedItemButton) {
            selectedItemButton.setAttribute('disabled', 'disabled');
          });
          this.setVisualFocusOn(false);
          this.closeAvailableItems();
        } else {
          this.inputElement.removeAttribute('disabled');
          this.openButtonElement.removeAttribute('disabled');
          this.searchAndSelectElement.classList.remove('dcf-search-and-select-disabled');
          this.selectedItemsListElement.removeAttribute('aria-disabled');
          this.selectedItemsListElement.querySelectorAll('button').forEach(function (selectedItemButton) {
            selectedItemButton.removeAttribute('disabled');
          });
        }
      }

      /**
       * Will turn the component's readonly mode on or off
       * @param { bool } boolReadOnly the new readonly state
       */
    }, {
      key: "setReadOnly",
      value: function setReadOnly(boolReadOnly) {
        var formattedBoolReadOnly = boolReadOnly;
        if (typeof formattedBoolReadOnly !== 'boolean') {
          formattedBoolReadOnly = false;
        }
        if (formattedBoolReadOnly) {
          this.inputElement.setAttribute('readonly', 'readonly');
          this.openButtonElement.setAttribute('readonly', 'readonly');
          this.selectedItemsListElement.setAttribute('aria-readonly', 'true');
          this.selectedItemsListElement.querySelectorAll('button').forEach(function (selectedItemButton) {
            selectedItemButton.setAttribute('readonly', 'readonly');
          });
          this.closeAvailableItems();
        } else {
          this.inputElement.removeAttribute('readonly');
          this.openButtonElement.removeAttribute('readonly');
          this.selectedItemsListElement.removeAttribute('aria-readonly');
          this.selectedItemsListElement.querySelectorAll('button').forEach(function (selectedItemButton) {
            selectedItemButton.removeAttribute('readonly');
          });
        }
      }

      /**
       * Determines if the visual focus is on the selected items list
       * @returns { bool } true if the selected items list has visual focus
       */
    }, {
      key: "visualFocusOnSelectedItems",
      value: function visualFocusOnSelectedItems() {
        return this.selectedItemsListElement.dataset.focused === 'true';
      }

      /**
       * Handles the functionality of selecting an available item
       * @param { HTMLLIElement } itemToSelect The available item to select
       */
    }, {
      key: "selectAvailableItem",
      value: function selectAvailableItem(itemToSelect) {
        if (!this.isElementAnAvailableItem(itemToSelect)) {
          throw new Error('Element is not an available item');
        }
        itemToSelect.setAttribute('aria-selected', 'true');
        this.selectElement.querySelectorAll('option').forEach(function (singleOption) {
          if (singleOption.value === itemToSelect.dataset.value) {
            singleOption.setAttribute('selected', 'selected');
          }
        });
        this.appendNewSelectedItem(itemToSelect);
      }

      /**
       * Handles the functionality of de-selecting an available item
       * @param { HTMLLIElement } itemToRemove The available item to de-select
       */
    }, {
      key: "removeAvailableItem",
      value: function removeAvailableItem(itemToRemove) {
        if (!this.isElementAnAvailableItem(itemToRemove)) {
          throw new Error('Element is not an available item');
        }
        _get(_getPrototypeOf(DCFSearchSelectMultiple.prototype), "removeAvailableItem", this).call(this, itemToRemove);
        this.selectedItemsListElement.querySelectorAll("li[data-id=\"".concat(itemToRemove.dataset.id, "\"]")).forEach(function (singleSelectedItem) {
          singleSelectedItem.remove();
        });
      }

      /**
       * Handles the functionality of de-selecting a selected item
       * @param { HTMLLIElement } itemToRemove The selected item to de-select
       */
    }, {
      key: "removeSelectedItem",
      value: function removeSelectedItem(itemToRemove) {
        if (!this.isElementASelectedItem(itemToRemove)) {
          throw new Error('Element is not a selected item');
        }
        var availableItem = this.availableItemsListElement.querySelector("li[data-id=\"".concat(itemToRemove.dataset.id, "\"]"));
        availableItem.setAttribute('aria-selected', 'false');
        this.selectElement.querySelectorAll('option').forEach(function (singleOption) {
          if (singleOption.value === availableItem.dataset.value) {
            singleOption.removeAttribute('selected');
          }
        });
        itemToRemove.remove();
        if (this.selectedItemsListElement.children.length === _dcfUtility.DCFUtility.magicNumbers('int0')) {
          this.inputElement.focus();
        }
      }

      /**
       * Calculates if the selected item is in view
       * @param { HTMLLIElement } itemToCheck The item to check if it is in view
       * @returns { bool } true if it is in view
       */
    }, {
      key: "isSelectedItemInView",
      value: function isSelectedItemInView(itemToCheck) {
        if (!this.isElementASelectedItem(itemToCheck)) {
          throw new Error('Element is not a selected item');
        }

        // Get the bounding client rect of the ul and li
        var listRect = this.searchAreaElement.getBoundingClientRect();
        var itemToCheckRect = itemToCheck.getBoundingClientRect();

        // Check if the li is vertically in view within the ul
        return itemToCheckRect.top >= listRect.top && itemToCheckRect.bottom <= listRect.bottom;
      }

      /**
       * Checks if the element has the class `dcf-search-and-select-selected-item`
       * @param { HTMLElement } elementToCheck The element to check
       * @returns { bool } true if it does contain that class
       */
    }, {
      key: "isElementASelectedItem",
      value: function isElementASelectedItem(elementToCheck) {
        return elementToCheck.classList.contains('dcf-search-and-select-selected-item');
      }
    }]);
    return DCFSearchSelectMultiple;
  }(DCFSearchSelectSingle);
  /**
   * DCF search and select component
   */
  var DCFSearchSelect = /*#__PURE__*/function () {
    // Set up the button
    function DCFSearchSelect(selects, theme) {
      _classCallCheck(this, DCFSearchSelect);
      if (theme instanceof DCFSearchSelectTheme) {
        this.theme = theme;
      } else {
        this.theme = new DCFSearchSelectTheme();
      }

      // Create a random ID for the button
      this.uuid = _dcfUtility.DCFUtility.uuidv4();

      // Store the button inputted (always will be an array )
      /** @type { Array<HTMLSelectElement> } */
      this.selects = selects;
      // eslint-disable-next-line no-prototype-builtins
      if (NodeList.prototype.isPrototypeOf(this.selects)) {
        this.selects = Array.from(this.selects);
      } else if (!Array.isArray(this.selects)) {
        this.selects = [this.selects];
      }
    }

    // The names of the events to be used easily
    _createClass(DCFSearchSelect, [{
      key: "initialize",
      value:
      // Initialize the buttons that were inputted in the constructor
      function initialize() {
        var _this9 = this;
        // Loops through each one
        this.selects.forEach(function (selectElement, index) {
          selectElement.setAttribute('id', selectElement.getAttribute('id') || _this9.uuid.concat('-search-and-select-label-', index));

          // Hides the select if it is not already done so
          if (selectElement.getAttribute('hidden') !== null) {
            selectElement.setAttribute('hidden', 'hidden');
          }

          // if it has multiple we will create the multiple select combobox
          // else we will just make a single select combobox
          // We have dedicated classes due to the amount of variables/state and methods these classes have
          if (selectElement.getAttribute('multiple') !== null) {
            var newMultiSelect = new DCFSearchSelectMultiple(selectElement, _this9.theme);
            newMultiSelect.init();
          } else {
            var newSingleSelect = new DCFSearchSelectSingle(selectElement, _this9.theme);
            newSingleSelect.init();
          }
        });
      }
    }], [{
      key: "events",
      value: function events(name) {
        // Define any new events
        var events = {};
        Object.freeze(events);

        // Return the name of the event if it exists if not it will return undefined
        return name in events ? events[name] : undefined;
      }
    }]);
    return DCFSearchSelect;
  }();
  _exports.DCFSearchSelect = DCFSearchSelect;
});

